import { render } from "./StaffPortalTourModal.vue?vue&type=template&id=649edd12&scoped=true"
import script from "./StaffPortalTourModal.vue?vue&type=script&lang=js"
export * from "./StaffPortalTourModal.vue?vue&type=script&lang=js"

import "./StaffPortalTourModal.vue?vue&type=style&index=0&id=649edd12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649edd12"]])

export default __exports__